import { useEffect, useState } from 'react';
import { apiErrorHandling } from '../api/apierrorhandling';
import { getAssetYearlyTaxReport } from '../api/stoApi';
import { generalStore } from '../stores/GeneralStore';

export const useAssetYearlyTaxReports = (assetId: string | undefined, reload: boolean, year?: string) => {
  // todo add type
  const [yearlyTaxReport, seYearlyTaxReport] = useState<any | null>(null);
  useEffect(() => {
    const load = async (assetId: string) => {
      generalStore.setIsLoading(true);
      try {
        const response = (await getAssetYearlyTaxReport(assetId, year)).data;
        seYearlyTaxReport(response.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    if (assetId) {
      load(assetId);
    }
  }, [assetId, reload, year]);
  return yearlyTaxReport;
};
